export default __webpack_public_path__ + "media/images/logo-65db5a4451c399f62e58e94124b28e01.svg";